/**
 * Handle promises like Rust and Go
 *
 * @param promise Promise to be handled
 * @returns A tuple with the error and the data
 * @example
 * const [error, data] = await handlePromise(fetch('https://api.github.com'));
 * if (error) {
 *  console.error(error);
 * } else {
 * console.log(data);
 * }
 */
export async function ptry<T = any, D = Error>(promise: Promise<T>) {
  return promise
    .then((data) => [data, null] as const)
    .catch((error) => [null, error as D] as const);
}

export function wait(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export default {
  wait,
};
